import React from 'react';
import { useTranslation } from 'react-i18next';

export function AIIslandScopeSelector({ value, onChange, scopes }) {
  const { t } = useTranslation();
  return (
    <div className="ai-island-scope" role="radiogroup" aria-label={t('common.a11y.assistantMode')}>
      {scopes.map((scope) => {
        const Icon = scope.icon;
        const isActive = value === scope.id;
        return (
          <button
            key={scope.id}
            type="button"
            className={`ai-island-scope__option${isActive ? ' is-active' : ''}`}
            onClick={() => onChange(scope.id)}
            role="radio"
            aria-checked={isActive}
          >
            {Icon && <Icon size={14} />}
            <span>{scope.label}</span>
          </button>
        );
      })}
    </div>
  );
}
